import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { t } from 'i18next';
import Select, { StylesConfig } from 'react-select';
import { Dropdown } from 'react-bootstrap';
import clsx from "clsx";
import fetchAPI from '../../../common/fetchAPI';
import Loader from '../../../common/Loader';
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getPageSizeArray, getValueFromResource, paginationStyles } from '../../../common/timeLiveFunction';
import {
    getTimeExpenseInvoiceList, checkedState, unCheckedState, updateIsListLoading, updateSearchPagination, updatePagination, updateAccountTimeExpenseBillingId,
    deleteAccountTimeExpenseBilling, updateTimeExpenseBillingIdForPrint, resetInvoiceFormLists, updateSorting, setAccountTimeExpenseBillingIdsState, setAllAccountTimeExpenseBillingIdsState,
    SendToXero
} from "../invoiceBillingSlice";
import { getPagePermissionsAsync } from '../../../common/GlobalSlice';
import CustomPagination from "../../../common/Pagination";
import moment from "moment";
import { ShowToast } from "../../../common/Toastr";
import { useDebounce } from '../../../_metronic/helpers';
import { useLocation, useNavigate } from 'react-router-dom';
import { ShowSwalForCanvas, ShowSwalWithConfirmation } from "../../../common/SweetAlert";
import InvoicePrintViewWidget from "./InvoicePrintViewWidget";
import PageSizeSelect from "../../../common/PageSizeSelect";
const AccountTimeExpenseBilling = () => {
    const dispatch = useAppDispatch();
    const { timeExpenseInvoiceList, startRec, pageSize, pageNo, search, totalItems, isSearch, isListLoading, isReload, checkedRecordsForBilled, accountTimeExpenseBillingIdForPrint, sortOrder, sortColumn, AccountTimeExpenseBillingIds, isAllChecked,recordsFiltered } = useAppSelector((state) => state.invoiceBilling);
    const { decimalPlaces, cultureInfoName, maxMenuHeight, pageId, menuList, IsAdd, IsEdit, IsDelete, invoiceNoPrefix } = useAppSelector((state) => state.globalState);
    const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
    const modelRef = useRef<any>(null);
    const navigate = useNavigate();
    const location = useLocation();
    let isXeroConnected = localStorage.getItem('isXeroConnected');
    // Xero work commet
    // const [xeroAccessToken, setXeroAccessToken] = useState<string>('');
    // const [xeroTenantId, setXeroTenantId] = useState<string>('');
    // const [xeroIsVisible, setXeroIsVisible] = useState<boolean>(false);

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    useEffect(() => {
        dispatch(getTimeExpenseInvoiceList()).unwrap()
            .then((result) => {
                setIsFirstTimeLoad(false);
            })
            .catch((error) => {
            })
        // Xero work commet
        // initXero();
    }, [isReload,pageNo, pageSize, sortOrder, sortColumn]);

    // Xero work commet
    // const initXero = () => {
    //     const storedXeroObject = localStorage.getItem('Xero');
    //     const XeroData = (storedXeroObject && storedXeroObject !== 'undefined') ? JSON.parse(storedXeroObject) : null;
    //     if (XeroData) {
    //         let base64String = "";
    //         let jsonString = "";
    //         let jsonObject = "";
    //         let javaobject = null;
    //         base64String = XeroData;
    //         jsonString = atob(base64String);
    //         //console.log('jsonString:',jsonString);
    //         jsonObject = JSON.parse(jsonString);
    //         //console.log('jsonObject:',jsonObject);
    //         javaobject = JSON.parse(jsonObject);
    //         //console.log('javaobject:',javaobject);
    //         //console.log('XeroData - access_token:',javaobject.access_token);
    //         if (javaobject.access_token) {
    //             //console.log('XeroData - tenants:',javaobject.tenants);
    //             if (javaobject.tenants.length > 0) {
    //                 setXeroAccessToken(javaobject.access_token);
    //                 setXeroTenantId((javaobject && javaobject.tenants && javaobject.tenants.length > 0) ? javaobject.tenants[0].tenantId : '');
    //                 setXeroIsVisible(true);
    //             }
    //         }
    //     }
    // }

    const handleAllXeroCheckboxChange = (e: any) => {
        let isChecked = e.target.checked;
        dispatch(setAllAccountTimeExpenseBillingIdsState(isChecked))
    }

    const handleXeroCheckboxChange = (e: any, AccountTimeExpenseBillingId: any) => {
        let isChecked = e.target.checked;
        dispatch(setAccountTimeExpenseBillingIdsState({ AccountTimeExpenseBillingId, isChecked }))
    }

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    }

    const updatePaidStatus = async () => {
        dispatch(updateIsListLoading(true));
        let result: any[] = [];
        timeExpenseInvoiceList.map((item) => {
            if (item.isSelected === 1) {
                result.push({ "AccountTimeExpenseBillingId": item.AccountTimeExpenseBillingId, "IsPaid": item.IsPaid });
            }
        })
        try {
            const response = await fetchAPI('api/V2/Invoice/TimeExpenseBilling', 'PUT', result, true);
            const json = await response.json();
            if (json.StatusCode === "200") {
                ShowToast('Success', 'Time Expense Update Successfully!', "success", "toast-top-right");
                dispatch(getTimeExpenseInvoiceList());
            } else {
                ShowToast('Error', 'Time Expense Update Failed!', "error", "toast-top-right");
            }
        } catch (error) {
            dispatch(updateIsListLoading(false));
        } finally {
            dispatch(updateIsListLoading(false));
        }
    }

    const debouncedSearchTerm = useDebounce(search, 500);
    useEffect(() => {
        dispatch(getTimeExpenseInvoiceList());
    }, [debouncedSearchTerm]);

    const onHandleSearch = (event: any) => {
        dispatch(updateSearchPagination(event.target.value));
    }

    const onHandlePageSizeChange = (selectedOption: any) => {
        let objects = {
            "startRec": 0,
            "pageSize": selectedOption.value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    const onHandlePageChange = (pageNumber: any) => {
        let objects = {
            "startRec": (pageNumber - 1) * Number(pageSize),
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    const onDeleteAccountTimeExpenseBilling = (id: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountTimeExpenseBilling(id)).then((result) => {
                        result.payload.id != "" ? ShowToast('Success', 'Time Expense Invoice Delete Successfully!', "success", "toast-top-right") :
                            ShowToast('Error', 'Time Expense Invoice Delete Failed!', "error", "toast-top-right");
                           
                    }).catch((error) => {
                    })
                }
            })
            .catch((error) => {
            });
    }

    const triggerInvoicePrintView = (id: any) => {
        dispatch(updateTimeExpenseBillingIdForPrint(id));
        modelRef.current.click();
    }

    const sendToXero = () => {
        if (AccountTimeExpenseBillingIds.length === 0) {
            ShowSwalForCanvas('Xero Integration Action', 'Please select at least one record to Xero.', 'warning');
            return;
        }
        ShowSwalWithConfirmation("Confirmation Required", `Are you sure you want to send the selected record's to Xero`, "Confirm")
            .then((result) => {
                if (result) {
                    if (AccountTimeExpenseBillingIds.length !== 0) {
                        let commaSeparatedIds = AccountTimeExpenseBillingIds.join(',');
                        let exportType = "Invoice";
                        dispatch(SendToXero({ commaSeparatedIds, exportType })).then((result) => {
                            result.payload.StatusCode === "200" ?
                                ShowToast('Success', result.payload.ResponseMessage, "success", "toast-top-right") :
                                ShowToast('Error', result.payload.ResponseMessage, "error", "toast-top-right");
                        }).catch((error) => {
                        })
                    }
                }
            })
            .catch((error) => {

            });
    }

    const updateTimeExpenseBillingId = (id: any) => {
        localStorage.setItem('storageTimeExpenseBillingId', id);
        dispatch(updateAccountTimeExpenseBillingId(id));
        // dispatch(addItemTimesheetBillingListFromBilling([{
        //     "AccountClientId": 0,
        //     "EmployeeName": "",
        //     "ProjectName": "",
        //     "TaskName": "",
        //     "AccountProjectTaskId": 0,
        //     "AccountProjectId": 0,
        //     "AccountTimeExpenseBillingTimesheetId": "",
        //     "Description": "",
        //     "BillingRate": 0.0,
        //     "BillHours": 0.0,
        //     "TotalAmount": 0.0,
        //     "AccountTaxCodeId1": null,
        //     "AccountTaxCodeId2": null,
        //     "TaxCode2": 0.0,
        //     "TaxCode1": 0.0,
        //     "ActualHours": 0.0,
        //     "ActualBillingRate": 0.0,
        //     "PartyName": "",
        //     "AccountTimeExpenseBillingId": "",
        //     "AccountEmployeeTimeEntryId": null,
        //     "ExchangeRate": null,
        //     "AccountEmployeeId": null,
        //     "TaxName1": null,
        //     "TaxName2": null,
        //     "IsSelected": true,
        //     "IsEditable": false,
        //     "ProjectTaskArray": [{ index: 0, taskArray: [] }]
        // }]));
        //dispatch(addItemTimesheetBillingListFromBilling([]));
        // dispatch(addItemExpenseBillingListFromBilling([{
        //     "ProjectName": null,
        //     "AccountProjectId": null,
        //     "AccountClientId": 0,
        //     "AccountTimeExpenseBillingExpenseId": "",
        //     "AccountTimeExpenseBillingId": "",
        //     "Description": "",
        //     "ActualExpenseAmount": 0,
        //     "BilledExpenseAmount": 0,
        //     "AccountExpenseId": null,
        //     "AccountExpenseName": null,
        //     "AccountExpenseTypeId": null,
        //     "ExpenseType": null,
        //     "ExchangeRate": 1,
        //     "AccountTaxCodeId1": null,
        //     "AccountTaxCodeId2": null,
        //     "TaxCode1": 0,
        //     "TaxCode2": 0,
        //     "AccountExpenseEntryId": "0",
        //     "TaxName1": null,
        //     "TaxName2": null,
        //     "IsSelected": true,
        //     "IsEditable": false
        // }]));
        //dispatch(addItemExpenseBillingListFromBilling([]));
        dispatch(resetInvoiceFormLists([]));
        navigate('/accountinvoiceform');
    }

    const onHandleSorting = (sortOrder: string, sortColumn: string) => {
        let objects = {
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "start": 0,
            "pageSize": pageSize,
            "pageNo": 1
        }
        dispatch(updateSorting(objects));
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }

    return (
        <>
            {isListLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Time Expense Invoice List')} */}
                        {/* {getValueFromResource('Invoice Management', dispatch, t)} */}
                        {getValueFromResource('Time Expense Invoice List', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={onHandleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search', dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={paginationStyles}
                                maxMenuHeight={maxMenuHeight}
                                options={getPageSizeArray()}
                                value={getPageSizeArray().find((option: any) => option.value == pageSize)}
                                onChange={onHandlePageSizeChange}
                                className='fs-7 fw-normal'
                            /> */}
                            <PageSizeSelect onChange={onHandlePageSizeChange} />
                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(timeExpenseInvoiceList.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={onHandlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={startRec}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div> */}
                        {(timeExpenseInvoiceList.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={onHandlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={startRec}
                                        t={t}
                                        recordsFiltered={recordsFiltered}
                                    />
                                </div>
                            </>
                        )}
                        {IsEdit && <>
                            <div className='bullet bg-secondary h-35px w-1px mx-3' style={{ display: checkedRecordsForBilled.length > 0 ? 'block' : 'none' }}></div>
                            <div className="text-muted me-5" style={{ marginRight: '2px', display: checkedRecordsForBilled.length > 0 ? 'block' : 'none' }}>
                                <span className="me-2" data-kt-user-table-select="selected_count">{checkedRecordsForBilled.length}</span>
                                {/* {t('Selected')} */}
                                {getValueFromResource('Selected', dispatch, t)}
                            </div>
                            <button type="button" className="btn btn-success btn-sm"
                                onClick={() => { updatePaidStatus() }}
                                style={{ marginRight: '2px', display: checkedRecordsForBilled.length > 0 ? 'block' : 'none' }}
                            >
                                <i className="bi bi-pencil-square fs-5 me-2"></i>
                                {/* {t('Update')} */}
                                {getValueFromResource('Update', dispatch, t)}
                            </button>
                        </>}
                        {/* {IsEdit && <>
                            <div className='bullet bg-secondary h-35px w-1px mx-3' style={{ display: timeExpenseInvoiceList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}></div>
                            <div className="text-muted me-5" style={{ marginRight: '2px', display: timeExpenseInvoiceList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                <span className="me-2" data-kt-user-table-select="selected_count">{timeExpenseInvoiceList.filter((item: any) => item.isSelected === 1).length}</span> {t('Selected')}
                            </div>
                            <button type="button" className="btn btn-success btn-sm"
                                onClick={() => { updateBilledStatus() }}
                                 style={{ marginRight: '2px', display: timeExpenseInvoiceList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                            >
                                <i className="bi bi-pencil-square fs-5 me-2"></i>
                                {t('Update')}
                            </button>
                        </>} */}
                        {isXeroConnected === "true" && <>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <button
                                type="button"
                                className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                onClick={() => {
                                    sendToXero();
                                }}
                                disabled={AccountTimeExpenseBillingIds.length === 0}
                            >
                                {/* {t('Send To Xero')} */}
                                {getValueFromResource('Send To Xero', dispatch, t)}
                            </button>
                        </>}
                        {IsAdd && <><div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <button
                                type="button"
                                className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                onClick={() => {
                                    updateTimeExpenseBillingId("");
                                }}
                            >
                                {/* {t('Add Invoice List')} */}
                                {getValueFromResource('Add Invoice', dispatch, t)}
                            </button>
                        </>}
                    </div>
                </div>
                {/* <div className='card-body py-3'> */}
                <div className="card-Report-body py-3">
                    <div className='table-responsive'>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                            <thead>
                                <tr className='thHeading align-middle'>
                                    <th style={{ width: '5%' }}>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                            <input
                                                className='form-check-input widget-9-check'
                                                type='checkbox'
                                                checked={isAllChecked}
                                                onChange={(e) => { handleAllXeroCheckboxChange(e) }}
                                            />
                                        </div>
                                    </th>
                                    <th style={{ width: '5%' }}>
                                        {/* {t("Billed")} */}
                                        {getValueFromResource('Paid', dispatch, t)}
                                    </th>
                                    <th style={{ width: '15%' }}
                                    // onMouseEnter={() => handleMouseEnter(1)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Client Name")} */}
                                        {getValueFromResource('Client Name', dispatch, t)}
                                        {sortColumn === '1' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 1 && 
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '10%' }}
                                    // onMouseEnter={() => handleMouseEnter(2)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Invoice No")} */}
                                        {getValueFromResource('Invoice No', dispatch, t)}
                                        {sortColumn === '2' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 2 && 
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '10%' }}
                                    // onMouseEnter={() => handleMouseEnter(3)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Invoice Date")} */}
                                        {getValueFromResource('Invoice Date', dispatch, t)}
                                        {sortColumn === '3' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 3 && 
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '40%' }}
                                    // onMouseEnter={() => handleMouseEnter(4)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Description")} */}
                                        {getValueFromResource('Description', dispatch, t)}
                                        {sortColumn === '4' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 4 && 
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th className="text-right" style={{ width: '10%'}}
                                    // onMouseEnter={() => handleMouseEnter(5)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Amount")} */}
                                        {getValueFromResource('Amount', dispatch, t)}
                                        {sortColumn === '5' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 5 && 
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '10%', textAlign: 'center' }}>
                                        {/* {t("Action")} */}
                                        {/* {getValueFromResource('Action', dispatch, t)} */}
                                    </th>
                                    {/* <th className='min-w-100px'>{t("Billed")}</th>
                                    <th className='min-w-125px'>{t("Client Name")}</th>
                                    <th className='min-w-100px'>{t("Invoice No")}</th>
                                    <th className='min-w-100px'>{t("Invoice Date")}</th>
                                    <th className='min-w-300px'>{t("Description")}</th>
                                    <th className='min-w-100px'>{t("Amount")}</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {timeExpenseInvoiceList.length > 0 && timeExpenseInvoiceList.map((item: any) => {
                                    return (
                                        <tr key={item.AccountTimeExpenseBillingId}>
                                            <td>
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        className='form-check-input widget-9-check'
                                                        type='checkbox'
                                                        checked={AccountTimeExpenseBillingIds.includes(item.AccountTimeExpenseBillingId)}
                                                        onChange={(e) => { handleXeroCheckboxChange(e, item.AccountTimeExpenseBillingId) }}
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div className="form-check form-switch form-check-custom">
                                                    <input
                                                        id="chkTimeOff"
                                                        className="form-check-input h-20px w-30px"
                                                        type="checkbox"
                                                        checked={item.IsPaid}
                                                        onChange={(e) => { handleCheckboxChange(e, item.AccountTimeExpenseBillingId) }}
                                                    />
                                                </div>
                                                {/* <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        className='form-check-input widget-9-check'
                                                        type='checkbox'
                                                        // checked={item.isSelected == 0 ? false : true}
                                                        checked={item.IsPaid}
                                                        onChange={(e) => { handleCheckboxChange(e, item.AccountTimeExpenseBillingId) }}
                                                    />
                                                </div> */}
                                            </td>
                                            <td>
                                                <a className='text-dark fw-bold d-block'>
                                                    {/* {item.PartyName} */}
                                                    {item.ClientName}
                                                </a>
                                            </td>
                                            <td>
                                                <a className='text-gray-800 d-block'>
                                                    {item.InvoiceNumber}
                                                </a>
                                            </td>
                                            <td>
                                                <a className='text-dark d-block'>
                                                    <i className="ki-outline ki-calendar-2 fs-5 text-dark"></i> 
                                                    {/* {`${moment.parseZone(item.InvoiceDate).format('DD MMM yy')}`} */}
                                                    {formatDateWithDateAndMonthName(item.InvoiceDate, cultureInfoName.toString())}
                                                </a>
                                            </td>
                                            <td>
                                                {item.Description}
                                            </td>
                                            <td>
                                                <a className='text-dark d-block text-right' style={{ paddingRight: 0, whiteSpace: 'nowrap' }}>
                                                    {item.CurrencyCode} {FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.GrandTotal, decimalPlaces)}
                                                </a>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // {t("More")}
                                                        {getValueFromResource('More', dispatch, t)}
                                                        data-tooltip-place="top"
                                                    >
                                                        <i className="bi bi-three-dots fs-7"></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                        {IsEdit && <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0"
                                                                onClick={() => {
                                                                    updateTimeExpenseBillingId(item.AccountTimeExpenseBillingId);
                                                                }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Edit')}`} */}
                                                                    {getValueFromResource('Edit', dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>}
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0"
                                                                ref={modelRef}
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#invoicePrintModal"
                                                                onClick={() => { triggerInvoicePrintView(item.AccountTimeExpenseBillingId) }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-printer fs-4 iconColor">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Print')}`} */}
                                                                    {getValueFromResource('Print', dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                        {IsDelete && <>
                                                            <div className='separator mb-1 mt-1 opacity-75'></div>
                                                            <div className='menu-hover-bg-danger'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0"
                                                                    onClick={() => { onDeleteAccountTimeExpenseBilling(item.AccountTimeExpenseBillingId) }}
                                                                >
                                                                    <span className="menu-icon custom-menu mb-2">
                                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title delete-menu custom-menu-fontsize">
                                                                        {/* {`${t('Delete')}`} */}
                                                                        {getValueFromResource('Delete', dispatch, t)}
                                                                    </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        {timeExpenseInvoiceList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found', dispatch, t)}
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <button ref={modelRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#invoicePrintModal">
                {/* Launch demo modal */}
                {getValueFromResource('Launch demo modal', dispatch, t)}
            </button>
            <InvoicePrintViewWidget modelRef={modelRef} />
        </>
    )
}

export default AccountTimeExpenseBilling